module.exports = __webpack_public_path__ + "4bdb61d5acf54df87ae17ff92de567f0.fbx";